import { Component, Input, OnInit, SimpleChanges } from '@angular/core';
import { Color } from 'ng2-charts';

@Component({
  selector: 'app-discussion-total-report-chart',
  templateUrl: './discussion-total-report-chart.component.html',
  styleUrls: ['./discussion-total-report-chart.component.scss']
})
export class DiscussionTotalReportChartComponent implements OnInit {
  @Input() dataReport: any
  title_report = '';


  public doughnutChartOptions: any = {
    plugins: {
      labels: {
        render: 'percentage',
        fontColor: 'black',
        position: 'outside',
        precision: 1,
        arc: true,
        fontSize: 12,
        textMargin: 4,
        fontStyle: 'bold'
      }
    }
  }
  public doughnutChartType = 'doughnut';
  public doughnutChart = {
    filter: {
      doughnutChartLabels: [],
      doughnutChartData: [
      ],
      name: "",
      total: 0
    },
    lastFilter: {
      doughnutChartLabels: [],
      doughnutChartData: [
      ],
      name: "",
      total: 0
    }
  }

  public doughnutChartColors: Color[] = [
    { backgroundColor: ["#0071c1", "#ffc001"] }
  ];


  //barchart
  public barChartOptions = {
    responsive: true,
    legend: {
      position: 'bottom'
    },

    // We use these empty structures as placeholders for dynamic theming.
    plugins: {
      //exportEnabled: 1,
      labels: {
        render: 'value',
        fontColor: 'black',
        position: 'outside',
        precision: 1,
        arc: true,
        fontSize: 12,
        textMargin: 0,
        fontStyle: 'bold',
      },
      datalabels: {
        anchor: 'end',
        align: 'end',
      },
      tooltip: '1',
    }
  };
  public barChartLabels: any[] = ['2006', '2007', '2008', '2009', '2010', '2011', '2012'];
  public barChartType = 'bar';
  public barChartLegend = true;
  public barChartColors: Color[] = [
    { backgroundColor: ["#0082bf", "#abe4ff"] },
    { backgroundColor: ["#0082bf", "#abe4ff"] }
  ];

  public barChartData = [
    { data: [65, 59, 80, 81, 56, 55, 40], label: 'Series A' },
    { data: [28, 48, 40, 19, 86, 27, 90], label: 'Series B' }
  ];

  constructor() {
    console.log(this.dataReport)
  }

  ngOnInit(): void {
  };
  ngOnChanges(changes: SimpleChanges) {
    console.log(this.dataReport)
    this.mappingData()
  }
  mappingData() {
    if (this.dataReport && this.dataReport.data) {
      this.mappingBarchart();
      if (this.dataReport.report_title) {
        this.title_report = this.dataReport.report_title;
      }
      let colorGeneral = this.dataReport.data.colorGeneral;
      //dataReportFilter
      this.doughnutChart.lastFilter.total = this.dataReport.data.dataLastReportFilter.total;
      this.doughnutChart.lastFilter.name = this.dataReport.data.dataLastReportFilter.name;
      let dataLastFilter = this.dataReport.data.dataLastReportFilter.data;
      this.doughnutChart.lastFilter["doughnutChartColors"] = [{ backgroundColor: [] }];
      this.doughnutChart.lastFilter.doughnutChartLabels = [];
      this.doughnutChart.lastFilter.doughnutChartData = [];
      for (const name in dataLastFilter) {
        this.doughnutChart.lastFilter.doughnutChartLabels.push(name);
        this.doughnutChart.lastFilter["doughnutChartColors"][0].backgroundColor.push(colorGeneral[name]);
        this.doughnutChart.lastFilter.doughnutChartData.push(dataLastFilter[name]);
      }

      //dataLastReportFilter
      this.doughnutChart.filter.total = this.dataReport.data.dataReportFilter.total;
      this.doughnutChart.filter.name = this.dataReport.data.dataReportFilter.name;
      let dataFilter = this.dataReport.data.dataReportFilter.data;
      this.doughnutChart.filter["doughnutChartColors"] = [{ backgroundColor: [] }];
      this.doughnutChart.filter.doughnutChartLabels = [];
      this.doughnutChart.filter.doughnutChartData = [];
      for (const name in dataFilter) {
        this.doughnutChart.filter.doughnutChartLabels.push(name);
        this.doughnutChart.filter["doughnutChartColors"][0].backgroundColor.push(colorGeneral[name]);
        this.doughnutChart.filter.doughnutChartData.push(dataFilter[name]);
      }
    }
  }

  mappingBarchart() {
    let dataFilter = this.dataReport.data.dataReportFilter;
    let dataLastFilter = this.dataReport.data.dataLastReportFilter;

    this.barChartLabels = Object.keys(dataFilter.data);
    this.barChartData[0].data = Object.keys(dataLastFilter.data).map(c => dataLastFilter.data[c]);
    this.barChartData[0].label = dataLastFilter.name;
    this.barChartData[1].data = Object.keys(dataFilter.data).map(c => dataFilter.data[c]);
    this.barChartData[1].label = dataFilter.name;

    let dataKeys = Object.keys(dataFilter.data);
    this.barChartColors[0].backgroundColor = dataKeys.map(() => "#abe4ff");
    this.barChartColors[1].backgroundColor = dataKeys.map(() => "#0082bf");

  }
}



// WEBPACK FOOTER //
// D:/Project/Nodejs/SocialListening_Cloud/frontend_cloud/src/app/views/reports-component/discussion-total-report-chart/discussion-total-report-chart.component.ts